import { ASSETS_NAMES } from '@/shared/utils/constants';
import { IonButton } from '@ionic/react';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ToggleInput from '../ToggleInput/ToggleInput';
import styles from './TermsConditions.module.css';

type Props = {
  assetId: string;
  termsHandler: () => void;
};

const TermsConditions: React.FC<Props> = ({ assetId, termsHandler }) => {
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const { t } = useTranslation();

  const handleTerms = useCallback(() => {
    setAcceptedTerms(!acceptedTerms);
  }, [acceptedTerms]);

  return (
    <>
      <ToggleInput
        name="terms"
        labelText={t('wallet.deposit.terms.address', {
          assetName: ASSETS_NAMES[assetId],
          assetSymbol: assetId.toUpperCase()
        })}
        toggleHandler={() => handleTerms()}
      />

      <div className={styles.buttonContainer}>
        <IonButton
          id="crypto-modal"
          expand="block"
          type="submit"
          shape="round"
          disabled={!acceptedTerms}
          onClick={() => termsHandler()}
          className={styles.nextButton}
        >
          <p className={styles.buttonText}>{t('general.continue')}</p>
        </IonButton>
      </div>
    </>
  );
};
export default TermsConditions;
